import * as React from 'react';
import { Form } from '@beehive/components';
import PropTypes from 'prop-types';
import messages from 'messages/Workbench/ProjectDetail';
import { isBlank } from 'utils';
import _ from 'lodash';

export interface BaseInfoProps {
  prefixCls: string;
  handleFormItems?: (formItems: any[], params?: any) => void;
}

const HALF_COL_PROPS = {
  itemColProps: { span: 12 },
  itemLabelColProps: { span: 8 },
  itemInputColProps: { span: 16 },
};
const FORM_PROPS_1 = {
  mode: 'show',
  isLabelVertical: false,
  className: 'basics',
  ...HALF_COL_PROPS,
};
const FORM_ITEMS_1 = [
  { key: 'translated_priority', label: 'priority' },
  { key: 'expect_end_at', label: 'expect_end_at' },
];

class BaseInfo extends React.Component<BaseInfoProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
    detail: PropTypes.object,
  };

  public render() {
    const { intl, detail = {} } = this.context;
    const { prefixCls, handleFormItems } = this.props;
    const className = `${prefixCls}-base-info`;
    const formItems = _.cloneDeep(FORM_ITEMS_1);

    if (handleFormItems) {
      handleFormItems(formItems, { detail });
    }

    return (
      <div className={className}>
        <Form {...FORM_PROPS_1}>
          {formItems.map((item: any) => {
            const label = `${intl.formatMessage(messages[item.label])}${intl.formatMessage(messages.colon)}`;
            const value = detail[item.key];
            return (
              <Form.Item {...item} key={item.key} label={label}>
                <div>{item.render ? item.render(value, { detail }) : isBlank(value) ? '--' : value}</div>
              </Form.Item>
            );
          })}
        </Form>
      </div>
    );
  }
}

export default BaseInfo;
